module.exports = __webpack_public_path__ + "static/media/notice3.797ea06c.png";